import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const SUPABASE_URL = 'https://pddtfiqmhaqcxtkzflbx.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBkZHRmaXFtaGFxY3h0a3pmbGJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE0NTg4NTUsImV4cCI6MjA3NzAzNDg1NX0.qsWhrmHc7PinmAzsx6r4EQwiZbEVcvEMpSXsuczzz3M'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase